<svelte:options accessors/>
<script lang="ts">
    import {createEventDispatcher} from "svelte";

    export let open = false;
    export let closeOption = false;
    export let checkout = false;

    const dispatch = createEventDispatcher();

    function close() {
        open = false;
        dispatch('close');
    }

</script>
{#if open}
    <section class="mainOverlay flex pb-1 pt-ii flex-col w-100" class:checkout={checkout}>
        <div class="flex-100">
            {#if closeOption}
                <div class="container">
                    <div class="box-r mb-0">
                        <div class="pointer" style="font-family: sans-serif; font-weight: 300; font-size: 30px"
                             on:click="{close}">&times;
                        </div>
                    </div>
                </div>
            {/if}
            <slot>

            </slot>
        </div>
        <slot name="actions">

        </slot>
    </section>
{/if}
<style>
    .mainOverlay {
        overflow-y: scroll;
        z-index: 99;
        position: relative;
        width: 100%;
        background: white;
        height: calc(100vh - 171px)
    }

    @media (min-width: 1024px) {
        .mainOverlay {
            height: calc(100vh - 74px);
        }
    }

    .mainOverlay.checkout {
        height: calc(100vh - 202px);
    }

</style>
